<template>
  <div>
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <h1 style="max-width: 800px"> Get individual QR.codes for your construction site to tag workpackages and material </h1>
      </template>
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 50px 20px 20px 20px' : 'padding: 50px 20px 30px 20px;'}`">
        Our QR-Codes are an easy accessible way to individually provide system data.
        Put the QR-Code to the takt area and show the needed information, tag the construction materials or resources. <br> <br>
        The QR-Codes are licensed and directly link to the specific information in the system for the people who have the access to the software.

        </p>
      </template>
      <template #image>
        <img style="border-radius: 10px" :width="$vuetify.breakpoint.smAndDown ? '70%' : '33%'" src="@/assets/TaktIngQRCode.jpg">
      </template>
    </HomeDetailInfoSiteOne>
  </div>
</template>

<script>
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'

export default {
  components: {
    HomeDetailInfoSiteOne
  }
}
</script>
